import { objectType } from 'types';
import { BaseXHR } from 'utils/axios';
import { addTicketType } from 'utils/helper';

export const getCartApi = (data: objectType) =>
  BaseXHR.$get('b2b/v1/cart/get', addTicketType(data));

export const updateCartApi = (data: objectType) =>
  BaseXHR.$post('b2b/v1/cart/update', addTicketType(data));

export const addCartApi = (data: objectType) =>
  BaseXHR.$post('b2b/v1/cart/add', addTicketType(data));

export const mergeTicketApi = (data: objectType) =>
  BaseXHR.$post('b2b/v1/cart/merge-new-item', addTicketType(data));

export const removeCartApi = (data: objectType) =>
  BaseXHR.$post('b2b/v1/cart/remove', addTicketType(data));

export const getPriceApi = (data: objectType) =>
  BaseXHR.$post('b2b/v1/cart/get-price', addTicketType(data));
